// extracted by mini-css-extract-plugin
export default {"label":"input_label__jQEra","text":"input_text__BSYXB","input":"input_input__MbZQL"};